import React, { Component } from 'react';
import './Modal.scss';

class Modal extends Component {
  state = { render: false, shown: false };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.showModal !== nextProps.showModal) {
      if (!nextProps.showModal) {
        this.setState({ shown: false });
        document.body.style.overflow = 'auto';
        setTimeout(() => {
          this.setState({ render: false });
        }, 300);
      } else {
        this.setState({ render: true });
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          this.setState({ shown: true });
        }, 1);
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.shouldClickAway.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.shouldClickAway);
    if (this.state.render && document.body.style.overflow === 'hidden') {
      document.body.style.overflow = 'auto';
    }
  }

  shouldClickAway(e) {
    const fullScreenMode = document.getElementById('shoutout-image-fullscreen') !== null;
    if (e.target.contains(document.getElementById('modalMenu')) && e.target.id !== 'modalMenu' && !e.key) this.props.closeModal();
    if (e && e.key && e.key === 'Escape' && this.props.showModal && this.state.shown && !fullScreenMode) {
      this.props.closeModal();
    }
  }

  renderHeader() {
    const { header } = this.props;
    if (header) {
      return <div className="modal-header">{header}</div>;
    }
    return null;
  }

  render() {
    const { width, style } = this.props;
    if (!this.state.render) return null;
    let className = this.state.shown ? 'modalBackdrop visible ' : 'modalBackdrop ';
    if (this.props.backdropClass) className += this.props.backdropClass;
    return (
      <div onClick={(e) => this.shouldClickAway(e)} className={className}>
        <div style={{ width, ...style }} id="modalMenu" className={"modalMenu " + this.props.className}>
          {this.renderHeader()}
          {this.props.children}
        </div>
      </div>
    );
  }
}

export { Modal };


// WEBPACK FOOTER //
// ./src/components/Modal.js